module.exports = __webpack_public_path__ + "img/selected0-min.921d3a78.png";